import ModalDeleteFilled from '../../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'

interface ModalDeleteSupplierBillingGroupProps extends ModalEditComponentProps { }

const ModalDeleteSupplierBillingGroup: React.FC<ModalDeleteSupplierBillingGroupProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/supplier/supplierBillingGroup/deleteBillingGroupSupplier',
        data: {
            BillingGroupId: allRowData?.BillingGroupId,
            SupplierId: allRowData?.SupplierId,
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDeleteBillingGroupSupplier', '¿Seguro quieres eliminar este grupo de facturación de este proveedor?'),
            subtitle: t('onceDeletedNotRecoverM', 'Una vez eliminado no podrás recuperarlo')
        }} />
    )
}

export default ModalDeleteSupplierBillingGroup